import React from 'react'
import { Route, withRouter } from 'react-router'
import UploaderList from './components/uploaderList'

const Uploader = () => {
    return (
        <>
            <Route path='/uploader' component={withRouter(UploaderList)} />
        </>
    )
}

export default Uploader